import { render } from "./default-block-root.vue?vue&type=template&id=4a96f754"
import script from "./default-block-root.vue?vue&type=script&lang=js"
export * from "./default-block-root.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__